/**
 *
 * @author      Marc-André Appel <marc-andre@sudimage.fr>
 * @copyright   2016 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        http://www.sudimage.fr
 */
/* globals $clamp */
(function ($) {
  var slickSlider = $('*[data-sudimage-slick]');
  if (slickSlider.length > 0) {
    $(document).ready(function() {
      slickSlider.each(function () {
        var $this = $(this);
        var slides = $this.attr('data-sudimage-slick');
        $(this).slick({
          infinite: true,
          slidesToShow: parseInt(slides),
          slidesToScroll: parseInt(slides),
          autoplay: true,
          appendDots: '.sudimage-slick-indicators',
          dots: true
        });
        $('.sudimage-slick-item-title', $this).each(function (index, element) {
          $clamp(element, {clamp: 1, useNativeClamp: false});
        });
        $('.sudimage-slick-item-description', $this).each(function (index, element) {
          $clamp(element, {clamp: 4, useNativeClamp: false});
        });
      });
    });
  }
})(jQuery);